import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SignUpForm.css';
import { resetAuthUI, startAuthUI } from '../data';

export default class SignUpForm extends Component {
  componentDidMount() {
    startAuthUI('firebaseui-auth', this.props.onSignIn);
  }

  componentWillUnmount() {
    resetAuthUI();
  }

  render() {
    return (
      <div id="firebaseui-auth"/>
    );
  }
}

SignUpForm.propTypes = {
  onSignIn: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/SignUpForm.js